import type { Catalog, ChapterMeta, Year } from "../content/types";
import type { ProgressMap } from "../services/progressService";

export function chaptersForYear(catalog: Catalog, year: Year, subjectId?: string): ChapterMeta[] {
  return catalog.chapters.filter((c) => c.years.includes(year) && (!subjectId || c.subjectId === subjectId));
}

/** Moyenne de complétion des chapitres d'une discipline pour une année (0-100). */
export function subjectCompletion(catalog: Catalog, progress: ProgressMap, subjectId: string, year: Year): number {
  const chapters = chaptersForYear(catalog, year, subjectId);
  if (!chapters.length) return 0;
  const sum = chapters.reduce((acc, c) => acc + (progress[c.id]?.completion || 0), 0);
  return Math.round(sum / chapters.length);
}

/** Chapitre à revoir aujourd'hui : commencé mais non maîtrisé, le plus ancien en activité. */
export function chapterToReview(catalog: Catalog, progress: ProgressMap, year: Year): ChapterMeta | null {
  const started = chaptersForYear(catalog, year)
    .filter((c) => progress[c.id] && (progress[c.id].completion || 0) < 100)
    .sort((a, b) => (progress[a.id].lastActivityAt || 0) - (progress[b.id].lastActivityAt || 0));
  return started[0] || null;
}

/** Dernier chapitre travaillé (pour « Continuer »). */
export function lastChapter(catalog: Catalog, progress: ProgressMap): ChapterMeta | null {
  const list = catalog.chapters
    .filter((c) => progress[c.id]?.lastActivityAt)
    .sort((a, b) => (progress[b.id].lastActivityAt || 0) - (progress[a.id].lastActivityAt || 0));
  return list[0] || null;
}
